import React, { useState, useEffect } from "react";
import { DateTimePicker } from "react-widgets";
import Select from "react-select";
import {
    mdiHome,
    mdiChevronDoubleRight,
    mdiDelete,
    mdiCartArrowDown,
    mdiPlus,
    mdiPrinter,
    mdiCartOutline,
    mdiPencil,
    mdiPlusCircleOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import iconCustomer from "../../../Resources/ImagesNew/Group2196.png";
import { convertToNumber } from "utils/currencyFormat";
import moment from "moment";
import { getUserLogin } from "utils/utils";
import { AutocompleteDiaChiGiaoHang } from "./AutocompleteDiaChiGiaoHang";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import { MultiSelect } from "react-multi-select-component";
import { pushNotification } from "utils/notifications";
export const ThongTinKhachHang = ({
    isShowTinhThanh,
    dataBanHang,
    setDataBanHang,
    roleHanThanhToan,
    DHQuaHanThanhToan,
    setDHQuaHanThanhToan,
    activePage,
    setPageActive,
    disEditKH,
    listNVKD,
    setListNVKD,
    HienThiChietKhau,
    HienThiChietKhauCoBien,
    setListChietKhauNhomKH,
    updateTienCKNhom,
    setFocusKho,
    setDisEditKH,
    EditID,
    disEditAll,
    isShowNVKDNew,
    listNVKDNew,
    setListNVKDNew,
}) => {

    useEffect(() => {
        DatHangApi.getChiTietKhachHangById(getUserLogin().UserName).then((response) => {
            if (response.status === 200) {

                const thongtin = { ...dataBanHang };
                thongtin.CustomerID = response.data.CustomerID;
                thongtin.CustomerName = response.data.CustomerName;
                thongtin.CustomerAddress = response.data.CustormerAddress;
                thongtin.HanThanhToan = null;
                thongtin.Phone = response.data.Phone;
                thongtin.NVKD = response.data.NVKDUserName;
                thongtin.NVKDID = response.data.NVKDID;
                thongtin.CustomerDebt = response.data.Debt * -1;
                thongtin.TaxCode = response.data.TaxCode;
                thongtin.SoNgayNo = response.data.SoNgayNo;
                thongtin.DiaChiGiaoHang = response.data.DiaChiGiaoHang;
                thongtin.ListAddress = response.data.ListAddress;
                setDataBanHang(thongtin);
            }
        });
    }, [dataBanHang.CustomerID]);

    const onChangeText = (field, e) => updateStateThongTin(field, e.target.value);
    const updateStateThongTin = (field, value) => {
        const thongtin = { ...dataBanHang };
        thongtin[field] = value;
        setDataBanHang(thongtin);
    };

    if (dataBanHang.lstChiTiet && dataBanHang.lstChiTiet.length > 0) {
        dataBanHang.lstChiTiet.map((category, index) => {
            if (category.IdPhieuGiaoNhan > 0) {
                setDisEditKH(true);
            }
        });
    }


    return (
        <>
            <div className="row">
                <div className="col-lg-4">
                    <h2 class="title-detail-new">
                        <img src={iconCustomer} alt="#" />
                        Thông tin đại lý
                    </h2>
                </div>
            </div>
            <div class="row select-address">
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main">Tên đại lý</label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.CustomerName}
                                disabled={true}
                            // onChange={(e) => onChangeText("CustomerName", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Địa chỉ
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.CustomerAddress}
                                onChange={(e) => onChangeText("CustomerAddress", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label
                                class="label-control text-left-main"
                                for="eventRegInput2"
                            >
                                Điện thoại
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder=""
                                value={dataBanHang.Phone}
                                onChange={(e) => onChangeText("Phone", e)}
                            />
                        </div>
                    </div>
                </div>


                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Mã số thuế
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder=""
                                value={dataBanHang.TaxCode}
                                onChange={(e) => onChangeText("TaxCode", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Địa chỉ giao hàng
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.DiaChiGiaoHang}
                                onChange={(e) => onChangeText("DiaChiGiaoHang", e)}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
